module.exports = __webpack_public_path__ + "static/media/patrocinio-home.6331df45.jpg";